import React, { useEffect, useRef, useState } from 'react'
import { Platform, ScrollView, Text, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack'
import { useDispatch, useSelector } from 'react-redux'
import { fetchOnDemand } from '../../Redux/Actions/onDemandAction'
import { useCssStyle } from '../../customHook/getCssStyle'
import { ImageComp } from '../../components/Image/Image'
import { getCleanUrl } from '../../utils/Helper'
import WebView from 'react-native-webview'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import Loader from '../../components/Loader/loader'
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer'
import { handleMessageEventListener } from '../../js/eventListener'
import { useNavigation } from '@react-navigation/native'

const OnDemand = () => {
    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const insets = useSafeAreaInsets();
    const navigate = useNavigation();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { isLoggedIn, onDemandData } = useSelector(state => state.appConfigSlice);

    const [loading, setLoading] = useState(true);

    const webViewRef = useRef();
    const iframeRef = useRef();

    useEffect(() => {
        if(!isLoggedIn){
            dispatch(setGoHome(true));
            dispatch(setShowLoginModal(true));
            return
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onDemandData])

    useEffect(() => {
        if (Platform.OS === 'web') {
          const handleMessage = (event) => {
            dispatch(handleMessageEventListener(event, iframeRef, navigate));
          };
    
          window.addEventListener('message', handleMessage);
    
          setTimeout(() => setLoading(false), 3000);
    
          return () => {
            window.removeEventListener('message', handleMessage);
          };
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    
    return (
        <View style={getStyles(['widgetRootContainer','onDemandRootContainer'])} id='widgetRootContainer onDemandRootContainer' >
            <HeaderWithBack />

            <ScrollView showsVerticalScrollIndicator={false} id="widgetmainContainer onDemandmainContainer" contentContainerStyle={getStyles(['widgetmainContainer', 'onDemandmainContainer'])}>
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'onDemandHeaderContainer',`onDemandHeaderContainer_${currentWidget?.widgetMetaHtmlId}`])} id={`onDemandHeaderContainer onDemandHeaderContainer_${currentWidget?.widgetMetaHtmlId}`}>
                    {
                        currentWidget?.widgetHeaderImageUrl && 
                            <ImageComp
                                source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                                style={getStyles(['widgetmainContainerHeaderImg', 'onDemandHeaderImg', `onDemandHeaderImg_${currentWidget?.widgetMetaHtmlId}`])} id={"onDemandHeaderImg"}
                            />
                    }
                    <View 
                        style={getStyles(['widgetmainContainerHeaderTitleContainer', 'onDemandHeaderTitleContainer', `onDemandHeaderTitleContainer_${currentWidget?.widgetMetaHtmlId}`])} 
                        id={`onDemandHeaderTitleContainer onDemandHeaderTitleContainer_${currentWidget?.widgetMetaHtmlId}`}
                    >
                        <Text
                            style={getStyles(['widgetmainContainerHeaderTitle', 'onDemandHeaderTitle', `onDemandHeaderTitle_${currentWidget?.widgetMetaHtmlId}`])} 
                            id={`onDemandHeaderTitle onDemandHeaderTitle_${currentWidget?.widgetMetaHtmlId}` }
                        >
                            {currentWidget?.widgetTitle}
                        </Text>
                    </View>
                </View>

                {onDemandData?.url && <View 
                    style={getStyles([
                        'widgetmainContainerChildContainer', 
                        'onDemandMainContainerChildContainer',
                        `onDemandMainContainerChildContainer_${currentWidget?.widgetMetaHtmlId}`, 
                        Platform.OS === 'android' && {marginBottom: insets.bottom}
                    ])}

                    id={`onDemandMainContainerChildContainer onDemandMainContainerChildContainer_${currentWidget?.widgetMetaHtmlId}`}
                >
                    {Platform.OS === 'web' ? (
                        <iframe
                            ref={iframeRef}
                            src={`${onDemandData?.url}?xsessiontoken=${onDemandData?.token}`}
                            style={getStyles([
                                'onDemand',
                                `onDemand_${currentWidget?.widgetMetaHtmlId}`,
                            ])}
                            title={currentWidget?.displayName}
                            onLoad={() => setLoading(false)}
                            id={`onDemand onDemand_${currentWidget?.widgetMetaHtmlId}`}
                        />
                        ) : (
                        <WebView
                            ref={webViewRef}
                            originWhitelist={['*']}
                            style={getStyles([
                                'onDemand',
                                `onDemand_${currentWidget?.widgetMetaHtmlId}`
                            ])}
                            source={{ 
                                uri: onDemandData?.url,
                                headers: {
                                    'x-session-token': onDemandData?.token,
                                },
                            }}
                            javaScriptEnabled={true}
                            allowsInlineMediaPlayback={true}
                            allowsFullscreenVideo={false}
                            
            
                            cacheEnabled={true}
                            onLoad={() => setLoading(false)}
                            onLoadStart={() => setTimeout(() => setLoading(false), 3000)}
                            onMessage={(event)=> dispatch(handleMessageEventListener(event, webViewRef, navigate))}
                        />
                    )}
                </View>}
            </ScrollView>

            {loading && (
                <View style={{ height: "100%", justifyContent: "center", alignItems: "center" }}>
                    <Loader style={getStyles(['crossOverContaniner_loader'])} />
                </View>
            )}
        </View>
    )
}

export default OnDemand
